export default __webpack_public_path__ + "static/media/ruslan.1caffabb.webp";